import { combineReducers } from "redux";
import bleService from "./ble/bleService";

export default combineReducers({
  bleService
});